import { render, staticRenderFns } from "./roleAction.vue?vue&type=template&id=0e9d3fed&scoped=true"
import script from "./roleAction.vue?vue&type=script&lang=js"
export * from "./roleAction.vue?vue&type=script&lang=js"
import style0 from "./roleAction.vue?vue&type=style&index=0&id=0e9d3fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d3fed",
  null
  
)

export default component.exports